import { render } from "./MainPettyCashHistory.vue?vue&type=template&id=3da71a31"
import script from "./MainPettyCashHistory.vue?vue&type=script&lang=js"
export * from "./MainPettyCashHistory.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__